<template>
  <q-page padding class="d-flex justify-center align-center">
    <q-row>
      <q-col>
        <h1 class="text-h1 text-center">Something went wrong.</h1>
        <p class="text-subtitle1 text-center">
          RoadFootage may be unavailable for maintenance or experiencing technical difficulties.
          Please try again later.
        </p>
      </q-col>
    </q-row>
  </q-page>
</template>
